import { render, staticRenderFns } from "./LicenseTypePara.vue?vue&type=template&id=790ca4d6&"
import script from "./LicenseTypePara.vue?vue&type=script&lang=ts&"
export * from "./LicenseTypePara.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports